import { gameEntryDestination } from '../player/entry-routing.js'

const destination = gameEntryDestination(location.search, location.hash)
if (destination) location.replace(destination)
else import('./experience.js')
